import { A11y, Autoplay, Controller, default as SwiperCore, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, Keyboard, Mousewheel, Navigation, Pagination, Parallax } from 'swiper';
import 'swiper/css/bundle';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';
SwiperCore.use([Navigation, Pagination, Parallax, A11y, EffectCreative, Controller, EffectCards, EffectCoverflow, EffectCube, EffectFade, EffectFlip, Mousewheel, Keyboard, Autoplay]);

@Component({ className: 'js-hero' })
export class HeroComponent {
	private slideCount = 0;
	private bgSlides;
	private descSlides;
	private activeIndex = 0;
	private previousIndex = 0;
	private autoplay = false;
	private nextBtn;
	private prevBtn;
	private timer;

	constructor(private element: HTMLElement) {
		this.bgSlides = element.querySelector('.js-hero-bg').querySelectorAll('.swiper-slide');
		this.descSlides = element.querySelector('.js-hero-desc').querySelectorAll('.swiper-slide');
		this.slideCount = this.descSlides.length;
		this.activeIndex = this.slideCount;
		this.nextBtn = element.querySelector<HTMLElement>('.js-hero-next');
		this.prevBtn = element.querySelector<HTMLElement>('.js-hero-prev');

		this.nextBtn.addEventListener('click', this.slideToNext.bind(this, true))
		this.prevBtn.addEventListener('click', this.slideToPrev.bind(this, true))

		const autoplayDelay = (parseInt(this.element.getAttribute('data-swiper-autoplay')) || 0);
		if (autoplayDelay > 0) {
			this.autoplay = true;
			this.timer = setInterval(this.slideToNext.bind(this, false), autoplayDelay)
		}

		this.slideToNext();

		setTimeout(() => {
			this.element.classList.remove('is-hidden');
		}, 100);
	}

	slideToNext(stopTimer = false) {
		if (stopTimer) {
			this.autoplay = false;
			clearInterval(this.timer);
		}

		this.previousIndex = this.activeIndex;
		this.activeIndex++;
		if (this.activeIndex >= this.slideCount) {
			this.activeIndex = 0;
		}
		this.animateTransition(true);
	}

	slideToPrev(stopTimer = false) {
		if (stopTimer) {
			this.autoplay = false;
			clearInterval(this.timer);
		}

		this.previousIndex = this.activeIndex;
		this.activeIndex--;
		if (this.activeIndex < 0) {
			this.activeIndex = this.slideCount - 1;
		}
		this.animateTransition(false);
	}

	animateTransition(gotoNext = true) {
		this.resetBg();
		this.setBgActiveSlideState(gotoNext);
		this.setBgPrevSlideState(gotoNext);

		this.resetDesc();
		this.setDescActiveSlideState(gotoNext);
		this.setDescPrevSlideState(gotoNext);
	}

	// ------------------------------------------------------

	resetBg() {
		for (let i = 0; i < this.slideCount; i++) {
			const slide = this.bgSlides[i];
			slide.querySelector('.js-hero-bg')?.classList.remove('fade-in', 'fade-out');
			slide.querySelector('.js-hero-title')?.classList.remove('slide-out-upwards', 'slide-in-upwards', 'slide-out-downwards', 'slide-in-downwards',);
			slide.style.opacity = '0';
			slide.style.zIndex = '0';
		}
	}

	setBgActiveSlideState(gotoNext = true) {
		const activeSlide = this.bgSlides[this.activeIndex] as HTMLElement;
		if (activeSlide) {
			activeSlide.querySelector('.js-hero-title')?.classList.add(gotoNext ? 'slide-in-upwards' : 'slide-in-downwards');
			if (gotoNext) {
				activeSlide.querySelector('.js-hero-bg')?.classList.add('fade-in');
			}

			activeSlide.style.opacity = '1';
			activeSlide.style.zIndex = gotoNext ? '10' : '1';
		}
	}

	setBgPrevSlideState(gotoNext = true) {
		const prevSlide = this.bgSlides[this.previousIndex] as HTMLElement;

		if (prevSlide) {
			prevSlide.querySelector('.js-hero-title')?.classList.add(gotoNext ? 'slide-out-upwards' : 'slide-out-downwards');
			prevSlide.style.opacity = '1';
			if (!gotoNext) {
				prevSlide.querySelector('.js-hero-bg')?.classList.add('fade-out');
				prevSlide.style.zIndex = '10';

				setTimeout(() => {
					prevSlide.style.zIndex = '0';
				}, 500);
			}
		}
	}

	// ------------------------------------------------------

	resetDesc() {
		for (let i = 0; i < this.slideCount; i++) {
			const slide = this.descSlides[i];
			slide.querySelector('.js-hero-caption')?.classList.remove('show');
			slide.querySelector('.js-hero-img')?.classList.remove('flip-out', 'flip-in');
			slide.querySelector('.js-hero-count-down')?.classList.remove('is-animating');
			slide.classList.remove('crop-out-prev', 'crop-in-prev', 'crop-out-next', 'crop-in-next',);
			slide.style.opacity = '0';
			slide.style.zIndex = '0';
		}
	}

	setDescActiveSlideState(gotoNext = true) {
		const activeSlide = this.descSlides[this.activeIndex] as HTMLElement;
		if (activeSlide) {
			activeSlide.querySelector('.js-hero-caption')?.classList.add('show');
			activeSlide.querySelector('.js-hero-img')?.classList.add('flip-in');

			activeSlide.classList.add(gotoNext ? 'crop-in-next' : 'crop-in-prev');
			activeSlide.style.opacity = '1';
			activeSlide.style.zIndex = gotoNext ? '10' : '1';

			if (this.autoplay) {
				activeSlide.querySelector('.js-hero-count-down')?.classList.add('is-animating');
			}
		}
	}

	setDescPrevSlideState(gotoNext = true) {
		const prevSlide = this.descSlides[this.previousIndex] as HTMLElement;

		if (prevSlide) {
			prevSlide.querySelector('.js-hero-img')?.classList.add('flip-out');
			prevSlide.classList.add(gotoNext ? 'crop-out-next' : 'crop-out-prev');
			prevSlide.style.opacity = '1';
		}
	}

	// helper
	private parseToBoolOrInt(el: HTMLElement, attr: string) {
		const val: string | null = el.getAttribute(attr);
		const parsedNum = Number.parseInt(val || 'false');
		return isNaN(parsedNum) ? val == 'true' : parsedNum
	}
}
